module.exports = __webpack_public_path__ + "img/assa-abloy.0882acc9.png";